import React, { Component }  from 'react';

class Workflows extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			active: false, 
			conversation: false,
			loading: false,
		};
	}
	
	activate = (conversation) => (e) => {
		this.setState({conversation: conversation.request.context.conversation_id})
	}
	
	cancel = () => {
		this.setState({conversation: false, loading: false, setting: false})
	}
	
	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}
	
	render() {
		if (this.props.active) {	
			var listed = {}
			var conversations = []
			for( var convo of this.props.data.Conversations.logs){
				if(!convo.request.context || !convo.request.context.companyPhone ){
					//Doesn't have context yet; ignore.
				}else if(!listed.hasOwnProperty(convo.request.context.conversation_id)){
					listed[convo.request.context.conversation_id] = 1
					conversations.push(convo)
				}else {
					listed[convo.request.context.conversation_id]++
				}
			}
			
				
			var activeConvo = ""
			if (this.state.conversation) {
				var segments = []
				for( var convo of this.props.data.Conversations.logs){
					if((convo.request.context && convo.request.context.conversation_id == this.state.conversation) || (convo.response.context && convo.response.context.conversation_id == this.state.conversation)){
						var response = ''
						for(var words of convo.response.output.text){
							response += words
						}
						var intents = ''
						for(var intent of convo.response.intents){
							intents += (' <' + intent.intent + '> ')
						}
						segments.unshift(
							<div>
							{convo.request.input ?
								<div>
									<div style={{textAlign: 'left', color: '#888', fontSize: '.7em'}}>{new Date(convo.request_timestamp).toLocaleString()}</div>
									<div style={{textAlign: 'left'}}>{ convo.request.input.text }</div>
								</div>
							:''}
								<div style={{textAlign: 'right', color: '#888', fontSize: '.7em'}}>{new Date(convo.response_timestamp).toLocaleString()}</div>
								<div  style={{textAlign: 'right', color: '#397'}}>{response}</div>
								<div style={{textAlign: 'right', color: '#937', fontSize: '.7em'}}>{intents}</div>
							</div>
						)
					}
				}
	
				
				activeConvo = (
					<div className="blackout" tabIndex="1" autoFocus>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>
							<div>Viewing details for Conversation: </div>
							<div style={{fontSize: '1.3em'}}>{this.state.conversation}</div>
							<br/>
							<div style={{fontSize: '1.1em'}}>Transcript:</div>
							{segments}
							
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>
							
							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.cancel}>Close Details</div>}
						</div>
					</div>
				)
			}
			
			var convoList = []
				for (var con of conversations) {
					if(listed[con.request.context.conversation_id] > 2) {
						convoList.push(
							<div className="dataRow"  key={con.request.context.conversation_id} onClick={this.activate(con)}>
								<span style={{flex: '0 0 300px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}} >{con.request.context.companyPhone}</span>
								<span style={{flex: '1 0 300px', textAlign: 'center', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}} >{new Date(con.request_timestamp).toLocaleString()}</span>
								<span style={{flex: '1 0 20%', textAlign: 'center'}}>{'Segments: (' + listed[con.request.context.conversation_id] +')'}</span>
							</div>
						)
					}
				}
			return (
				<div className="viewContent" >
					<div className="dataHeaders">
						<span style={{flex: '0 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="enabled">Phone Number</span>
						<span style={{flex: '1 0 300px', cursor: 'pointer'}} onClick={this.sort} data-sortBy="modified">Timestamp</span>
						<span style={{flex: '1 0 20px', cursor: 'pointer', textAlign: 'center'	}} onClick={this.sort} data-sortBy="name">Conversation Segments</span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 40px)'}}>
						{convoList}
							{activeConvo}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

export default Workflows


// WEBPACK FOOTER //
// ./src/Views/Conversations.js